/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type AccidentTypeDefinitionDto = {
    createdBy?: string;
    createdDate?: string;
    lastModifiedBy?: string;
    lastModifiedDate?: string;
    deleted?: boolean;
    id?: string;
    firmId?: string;
    predefinedId?: string;
    source?: AccidentTypeDefinitionDto.source;
    label?: string;
}

export namespace AccidentTypeDefinitionDto {

    export enum source {
        SYSTEM = 'SYSTEM',
        USER_DEFINED = 'USER_DEFINED',
    }


}
